/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

// Equalize slide heights for carousels that opt in via data-equalize-height
function equalizeGliderHeights(carousel) {
  var slides = carousel.querySelectorAll(':scope > .product-loop > .product');
  if (!slides.length) return;

  // Reset so we measure natural heights
  slides.forEach(function(s) { s.style.height = ''; });

  var maxH = 0;
  slides.forEach(function(s) { maxH = Math.max(maxH, s.offsetHeight); });
  slides.forEach(function(s) { s.style.height = maxH + 'px'; });
}

document.addEventListener('glider-loaded', function(e) {
  var carousel = e.target;
  if (carousel.dataset.equalizeHeight === 'true') {
    equalizeGliderHeights(carousel);
  }
});

document.addEventListener('glider-refresh', function(e) {
  var carousel = e.target;
  if (carousel.dataset.equalizeHeight === 'true') {
    equalizeGliderHeights(carousel);
  }
});

window.addEventListener('resize', function() {
  document.querySelectorAll('[data-equalize-height="true"]').forEach(function(carousel) {
    equalizeGliderHeights(carousel);
  });
});

function initDhFaqSidebar(scope) {
  var containers = (scope || document).querySelectorAll('.dh-faq-desktop');
  containers.forEach(function(container) {
    var tabs = container.querySelectorAll('.dh-faq-nav-item');
    var panels = container.querySelectorAll('.dh-faq-panel');
    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });
        panels.forEach(function(p) {
          p.classList.add('hide');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');
        panels[index].classList.remove('hide');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initDhFaqSidebar(document);
});

document.addEventListener('shopify:section:load', function(e) {
  initDhFaqSidebar(e.target);
});
